// Temporary feature flags. Flip the boolean to restore the feature.
// Restore = single boolean change; all underlying code stays intact.
//
// Hides the Settings -> Billing tab + the "upgrade plan" CTAs that link
// to it (GatedRoute splash, Contacts seat-limit modal). All Stripe wiring
// (PRICE_IDS, handleUpgrade, create-checkout-session, create-portal-session,
// stripe-webhook, lib/billing.ts) stays intact — UI only.
export const SHOW_BILLING_TAB = false

// Shows the Settings -> Appearance theme picker (dark/light/sepia). Replaces
// the previous localStorage dev gate (isThemeDevFlagOn). Enabled once the
// token migration covered the active surfaces — see docs/token-migration-plan.md.
export const SHOW_APPEARANCE_TAB = true

// Portal companion notifications (request_converted / job_scheduled /
// job_completed). Default ON. Disable to silence ALL staff-triggered
// portal emails across the workspace; for per-workspace control later,
// the workspaces.settings JSONB column already exists as the data
// shape — wire a per-workspace check at the helper level when that
// becomes the right call. See lib/portalNotify.ts for the call site.
export const PORTAL_NOTIFICATIONS = true
